import CrudCustom from '../../../libs/custom/CrudCustom';

let UsersService = new CrudCustom('/users');
export default UsersService
